import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useFortuneData } from '../contexts/FortuneContext';
import '../styles/HistoryPage.css';

const HistoryPage = () => {
  const { t } = useTranslation();
  const { getFortuneHistory } = useFortuneData();
  const history = getFortuneHistory();

  return (
    <div className="history-page">

      <div className="history-content">
        {history.length > 0 ? (
          <div className="history-list">
            {history.map(item => (
              <Link 
                to={`/history/${item.id}`} 
                className="history-item" 
                key={item.id}
              >
                <div className="history-item-content">
                  <div className="history-item-image">
                    <div className="placeholder-image" style={{ width: '100%', height: '100%', backgroundColor: '#f0f0f0', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                      <span>{t(item.product.titleKey).substring(0, 10)}...</span>
                    </div>
                  </div>
                  <div className="history-item-info">
                    <h3>{t(item.product.titleKey)}</h3>
                    <p className="history-date">
                      {new Date(item.date).toLocaleDateString()}
                    </p>
                  </div>
                </div>
                <span className="history-arrow">→</span>
              </Link>
            ))}
          </div>
        ) : (
          <div className="no-history">
            <p>{t('no_readings_yet')}</p>
            <Link to="/" className="start-reading-link">
              {t('start_reading')}
            </Link>
          </div>
        )}
      </div>
    </div>
  );
};

export default HistoryPage;
